/**
 * Who can edit or delete a Community Events post: its signed-in author, or an admin
 * (PR #88 review, 2026-10-29: admins could act from EventsList but the card hid the buttons).
 */
export function canManageEventPost(event, user) {
  if (!event || !user?.uid || user.isAnonymous === true) return false;
  return event.userId === user.uid || user.userType === 'admin';
}
